export class ManagerDetails {
    Name : string;
    Email : string;

    constructor() {
        this.Name = "";
        this.Email = "";
    }
}